import ROUTES from '../routes';
import ExchangeTransactions from '../hoc/exchange/exchange';
import ExchangeTransaction from '../hoc/exchange/transaction';
import ExpandedGeneralLedgerTransaction from '../hoc/transactions/expanded-general-ledger-panel';

const ExchangeRoutes = {
  path: ROUTES.EXCHANGE,
  element: <ExchangeTransactions />,
  children: [
    {
      path: ROUTES.EXCHANGE_READ,
      element: <ExchangeTransaction />,
    },
    {
      path: ROUTES.EXCHANGE_CREATE,
      element: <ExchangeTransaction />,
    },
    {
      path: ROUTES.EXCHANGE_GL,
      element: <ExpandedGeneralLedgerTransaction backLink={ROUTES.EXCHANGE} />,
    },
  ],
};

export default ExchangeRoutes;
